module.exports = __webpack_public_path__ + "media/images/logo-gasco-8118bf0b.svg";